import * as yup from 'yup';

// Utilities

import { isRif } from '../../../utilities/validations.helper-functions';

export const validationSchema = yup.object().shape({
  cliente: yup.object().shape({
    nombre: yup.string().required('Este campo es requerido'),
    primerApellido: yup.string().required('Este campo es requerido'),
    segundoApellido: yup.string(),
    fechaNacimiento: yup.string().required('Este campo es requerido'),
    tipoDocumento: yup.string().required('Este campo es requerido'),
    cedulaRif: yup.string().when("tipoDocumento", {
      is: (val) => val !== 'P' && val !== undefined && val !== '',
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
    pasaporte: yup.string().when("tipoDocumento", {
      is: (val) => val === 'P',
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
    fechaVenceIdentificacion: yup.string().required('Este campo es requerido'),
    sexo: yup.string().required('Este campo es requerido'),
    tipoRif: yup.string().required('Este campo es requerido'),
    rif: yup.string().required('Este campo es requerido').test("validacionRif", "Por favor ingrese un rif válido.", function (value) {
      if (this.parent.tipoRif && value) {
        return isRif(this.parent.tipoRif + value, this.parent.nacionalidad);
      } else {
        return false;
      }
    }),
    nacionalidad: yup.string().required('Este campo es requerido'),
    codigoOtraNacionalidad: yup.string(),
    lugarNacimiento: yup.string().required('Este campo es requerido'),
    estadoNacimiento: yup.string().when("lugarNacimiento", {
      is: (val) => val === '0',
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
    ciudadNacimiento: yup.string().when("lugarNacimiento", {
      is: (val) => val === '0',
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
    cargaFamiliar: yup.string().required('Este campo es requerido'),
    estadoCivil: yup.string().required('Este campo es requerido'),
    // tipoCliente: yup.string().required('Este campo es requerido'),
    caracteristicaCliente: yup.string().required('Este campo es requerido'),
    profesion: yup.string().required('Este campo es requerido'),
    actividadEspecifica: yup.string().required('Este campo es requerido'),
    actividadEconomica: yup.string().required('Este campo es requerido'),
    categoriaEspecial: yup.string().required('Este campo es requerido'),
    nivelAcademico: yup.string().required('Este campo es requerido'),
  }),
});